import React, { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollSmoother } from 'gsap/ScrollSmoother'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

const ScrollSmootherProvider = ({
  children,
  smooth = 1.2,
  smoothTouch = 0.1,
  effects = true
}) => {
  const wrapperRef = useRef(null)
  const contentRef = useRef(null)

  useGSAP(
    () => {
      if (!wrapperRef.current || !contentRef.current) {
        return
      }

      const smoother = ScrollSmoother.create({
        wrapper: wrapperRef.current,
        content: contentRef.current,
        smooth,
        smoothTouch,
        effects
      })

      return () => smoother?.kill()
    },
    { dependencies: [] }
  )

  return (
    <div id="smooth-wrapper" ref={wrapperRef}>
      <div id="smooth-content" ref={contentRef}>
        {children}
      </div>
    </div>
  )
}

export default ScrollSmootherProvider

